import { render, staticRenderFns } from "./default-button.vue?vue&type=template&id=968ba3e6&scoped=true&"
import script from "./default-button.vue?vue&type=script&lang=js&"
export * from "./default-button.vue?vue&type=script&lang=js&"
import style0 from "./default-button.vue?vue&type=style&index=0&id=968ba3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968ba3e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
